/**
 * Address formatting utilities for consistent display
 */

/**
 * Formats an address string to title case for consistent display
 * @param {string} address - The address string to format
 * @returns {string} - Formatted address in title case
 */
export const formatAddressForDisplay = (address) => {
  if (!address || typeof address !== 'string') {
    return 'N/A';
  }

  // Convert to title case while preserving abbreviations like "NJ", "NY", etc.
  return address
    .toLowerCase()
    .split(' ')
    .map(word => {
      // Keep state abbreviations in uppercase
      if (word.length === 2 && /^[a-z]{2}$/.test(word)) {
        return word.toUpperCase();
      }
      
      // Keep ZIP codes as-is (5 digits or 5+4 format)
      if (/^\d{5}(-\d{4})?$/.test(word)) {
        return word;
      }
      
      // Capitalize first letter of each word
      if (word.length > 0) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      
      return word;
    })
    .join(' ');
};

/**
 * Formats city and state combination for consistent display
 * @param {string} city - The city name
 * @param {string} state - The state abbreviation
 * @returns {string} - Formatted "City, STATE" string
 */
export const formatCityState = (city, state) => {
  const formattedCity = city ? formatAddressForDisplay(city) : '';
  const formattedState = state ? state.toUpperCase() : '';
  
  if (formattedCity && formattedState) {
    return `${formattedCity}, ${formattedState}`;
  } else if (formattedCity) {
    return formattedCity;
  } else if (formattedState) {
    return formattedState;
  }
  
  return 'N/A';
};

/**
 * CSS classes for consistent address styling
 */
export const addressStyles = {
  // Monospace font with consistent styling
  address: "font-mono text-sm text-gray-900 leading-relaxed tracking-wide",
  cityState: "font-mono text-sm text-gray-700 leading-relaxed tracking-wide",
  
  // For hover states
  addressHover: "font-mono text-sm text-gray-900 leading-relaxed tracking-wide hover:text-[#72d684] transition-colors duration-200",
  
  // Container for address block
  container: "space-y-1"
};










